/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import * as React from 'react';
import { useDispatch } from 'react-redux';
import { Formik } from 'formik';
import { Typography } from '@mui/material';
import { toast } from 'react-toastify';
import OrgAuthProviderForm from './OrgAuthProviderForm';
import { editOrgAuthProvider } from '../../../../../../../services/organization/OrgAuthProvider';
import { getAllOrgsAuthProviders, getAllOrgsAuthProvidersByOrgID } from '../../../../../../../store/reducers/organization/orgAuthProvider/orgAuthProviderAction';
import { useParams } from 'react-router-dom';
const OrgAuthProviderEdit = ({ handleClose, selectedOrgAuthProvider }) => {
    const dispatch = useDispatch();
    const {orgid} = useParams()
    const handleSubmit = async ({ detailName, detailValue }, { setSubmitting }) => {
        try {
            setSubmitting(true)
            await editOrgAuthProvider({
                organizationAuthProviderID: selectedOrgAuthProvider.organizationAuthProviderID, organizationAuthProviderDetails: [
                    {
                        detailName: detailName,
                        detailValue: detailValue
                    }]
            })
            toast.success('Organization Identity Provider  was edited successfully');
            handleClose();
            if (orgid?.length > 0) {
                await dispatch(getAllOrgsAuthProvidersByOrgID({ 'organizationID': orgid })).unwrap();

            } else {
                await dispatch(getAllOrgsAuthProviders()).unwrap();

            }
            setSubmitting(false)

        } catch (error) {

            setSubmitting(false)
            toast.error(error?.response?.data?.error?.message);
        }
    }

    return (
        <>
            <Typography variant='h2' color="primary" align='center' style={{ margin: '30px' }}>Organization Identity Provider Edit</Typography>
            <Formik
                initialValues={{
                    detailName: selectedOrgAuthProvider.organizationAuthProviderDetails[0].detailName,
                    detailValue: selectedOrgAuthProvider.organizationAuthProviderDetails[0].detailValue,

                }}
                onSubmit={(
                    values, { setSubmitting }
                ) => {
                    handleSubmit(values, { setSubmitting })
                }
                }
            >
                {({ values, handleBlur, handleChange, setFieldValue, isSubmitting, errors, touched }) => (
                    <OrgAuthProviderForm
                        values={values}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        setFieldValue={setFieldValue}
                        isSubmitting={isSubmitting}
                        handleClose={handleClose}
                        errors={errors}
                        touched={touched} />
                )}
            </Formik>
        </>
    )

}


export default OrgAuthProviderEdit;